import urlHelper from '../../../../utils/urlHelper';

const base = '/multi-media-wizard';

/**
 * @typedef {import('../types/ContentItems').ContentItem} ContentItem
 * @typedef {import('../flow/WizardFlowResponse').WizardFlowResponse} WizardFlowResponse
 */

function getBaseUrl() {
  return base;
}

/**
 * Cleans up URL parameters that are not needed.
 * @param {History} history - The history object to manipulate the URL.
 * @param {number|null} editSequenceId - The current edit sequence ID.
 */
function cleanupUrlParams(history, editSequenceId) {
  const baseUrl = getBaseUrl();
  const sequenceIdPart = editSequenceId ? `/${editSequenceId}` : '';

  history.push(`${baseUrl}${sequenceIdPart}`);
}

export default {
  getBaseUrl,
  getUrlParam: urlHelper.getUrlParam,
  setUrlParam: urlHelper.setUrlParam,
  cleanupUrlParams,
};
